module.exports = __webpack_public_path__ + "img/bannerLabel2Green.8d721b61.png";